import React from 'react'
import { Card, Input, Space, Button, Select, Spin } from 'antd'
import { SearchOutlined, PlusOutlined } from '@ant-design/icons'
import { useProducts } from '../hooks/useProducts'
import { useProductActions } from '../hooks/useProductActions'
import { ProductsTable } from '../components/ProductsTable'
import { ProductDetailsDrawer } from '../components/ProductDetailsDrawer'
import { ProductFormModal } from '../components/ProductFormModal'

const { Option } = Select

export const ProductsScreen: React.FC = () => {
    const {
        products,
        categories,
        searchText, setSearchText,
        categoryFilter, setCategoryFilter,
        statusFilter, setStatusFilter,
        isLoading,
        isFetching
    } = useProducts()

    const {
        selectedProduct,
        isDetailDrawerOpen,
        isFormModalOpen,
        editingProduct,
        handleViewDetails,
        handleAddProduct,
        handleEditProduct,
        handleDeleteProduct,
        handleFormSubmit,
        closeDrawer,
        closeFormModal,
        isCreating,
        isUpdating
    } = useProductActions()

    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Card>
                <Space style={{ marginBottom: 16 }}>
                    <Input
                        placeholder="Search products..."
                        prefix={<SearchOutlined />}
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        style={{ width: 300 }}
                    />
                    <Select
                        placeholder="Filter by category"
                        style={{ width: 150 }}
                        value={categoryFilter}
                        onChange={setCategoryFilter}
                    >
                        <Option value="all">All Categories</Option>
                        {categories.map((cat: any) => (
                            <Option key={cat.id} value={cat.name}>{cat.name}</Option>
                        ))}
                    </Select>
                    <Select
                        placeholder="Filter by status"
                        style={{ width: 150 }}
                        value={statusFilter}
                        onChange={setStatusFilter}
                    >
                        <Option value="all">All Status</Option>
                        <Option value="active">Active</Option>
                        <Option value="inactive">Inactive</Option>
                    </Select>
                    <Button type="primary" icon={<PlusOutlined />} onClick={handleAddProduct}>
                        Add Product
                    </Button>
                </Space>

                <Spin spinning={isLoading || isFetching}>
                    <ProductsTable
                        products={products}
                        onRowClick={handleViewDetails}
                        onEdit={handleEditProduct}
                        onDelete={handleDeleteProduct}
                    />
                </Spin>
            </Card>

            <ProductDetailsDrawer
                product={selectedProduct}
                open={isDetailDrawerOpen}
                onClose={closeDrawer}
                onEdit={handleEditProduct}
                onDelete={handleDeleteProduct}
            />

            <ProductFormModal
                open={isFormModalOpen}
                onCancel={closeFormModal}
                onSubmit={handleFormSubmit}
                initialValues={editingProduct}
                isLoading={isCreating || isUpdating}
            />
        </Space>
    )
}
